<template>

    <div>

        <app-head :title="category.meta_title || category.name">
            <meta name="description" :content="category.meta_description" v-if="category.meta_description">
        </app-head>

        <div class="text-white bg-light p-3 p-lg-5 position-relative">
            <div class="container">
                <div class="row align-items-center text-dark">
                    <div class="col-8">
                        <h1 class="category-title">
                            {{ category.name }}
                        </h1>
                        <div class="lead" v-if="category.description" v-html="category.description">
                        </div>
                    </div>
                    <div class="col-4" v-if="category.image_url">
                        <img :src="category.image_url" alt="" class="img-fluid" loading="lazy">
                    </div>
                </div>
            </div>
        </div>

        <div class="container my-3 my-lg-5">
            <breadcrumbs :items="breadcrumbs" />
        </div>

        <div class="container my-3 my-lg-5" v-if="page <= 1 && category.children.length">
            <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-6 g-3">
                <div class="col" v-for="childCategory in category.children">
                    <div class="card h-100">
                        <img class="card-img-top" :src="childCategory.image_url" style="height: 150px; cursor: pointer; object-fit: contain;" loading="lazy">
                        <div class="card-body">
                            <h6 class="card-title text-center m-0">
                                <inertia-link :href="childCategory.permalink" class="link-dark stretched-link">
                                    {{ childCategory.name }}
                                </inertia-link>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">

            <div class="my-5">
                <filters :filters="filters"
                         :supplier-options="supplierOptions"
                         :manufacturer-options="manufacturerOptions"
                         :payment-method-options="paymentMethodOptions"
                         :brand-options="brandOptions"
                         :min-price="minPrice"
                         :max-price="maxPrice"
                         />
            </div>

            <results :total="category.number_products" :from="products.meta.from" :to="products.meta.to" :filters="filters" @loading="setLoading" />

            <product-list :products="products.data" />

            <simple-pagination :links="products.links" />

        </div>

    </div>

</template>

<script>
    import Results from '@/shared/Results';
    import Filters from '@/shared/Filters';
    import SimplePagination from '@/shared/SimplePagination';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import ProductList from '@/shared/ProductList';

    export default {
        props: [
            'page',
            'category',
            'filters',
            'products',
            'supplierOptions',
            'manufacturerOptions',
            'brandOptions',
            'paymentMethodOptions',
            'minPrice',
            'maxPrice',
            'categoryTrail',
        ],
        data() {
            return {

            }
        },
        components: {
            Results,
            Filters,
            SimplePagination,
            Breadcrumbs,
            ProductList,
        },
        computed: {
            breadcrumbs() {
                var items = [{url: this.route('categories.index'), label: this.__('Categories')}];
                
                for (let i in this.categoryTrail) {
                    items.push({url: this.route('categories.show', this.categoryTrail[i].path), label: this.categoryTrail[i].name});
                }

                items.push({url: this.route('categories.show', this.category.path), label: this.category.name});
                return items;
            }
        },
        methods: {
            setLoading(bool) {
                this.loading = bool;
            }
        },
    }
</script>